import { createAction } from '../../utils/reduxUtils';
import { Callback } from '../../utils/helper/promisify';
import { IFirebaseUser } from '../../models';
import { AsyncError } from '../../common';

const switchAccount = createAction('@app/SWITCH_ACCOUNT')<{
  credential: any;
  done: Callback<AsyncError, void>;
}>;

const upgradeAccount = createAction('@app/UPGRADE_ACCOUNT')<{
  user: IFirebaseUser;
  done: Callback<AsyncError, void>;
}>;

const setAuthorities = createAction('@app/SET_AUTHORITIES')<{
  authorities: string[];
}>;

const appUpdate = {
  request: createAction('@app/APP_UPDATE_REQUEST')<void>,
  cancel: createAction('@app/APP_UPDATE_CANCEL')<void>,
  updateAvailable: createAction('@app/APP_UPDATE_AVAILABLE')<void>,
  updateApp: createAction('@app/APP_UPDATE_UPDATE')<void>,
};

const actions = {
  switchAccount,
  upgradeAccount,
  setAuthorities,
  appUpdate,
};

export default actions;
